// Never substitute the first business/client when an invoice's party is missing.
export function resolveInvoiceParties(invoice, businesses = [], clients = [], draft) {
  const issuerId = draft?.issuerId || invoice.issuerId;
  const clientId = draft?.clientId || invoice.clientId;
  const recorded = recordedInvoiceParties(invoice, draft);
  if (recorded) return recorded.issuer?.id === issuerId && recorded.client?.id === clientId ? recorded : { issuer: null, client: null };
  if (!issuerId) return { issuer: null, client: null };
  const inWorkspace = item => !invoice.workspaceId || !item.workspaceId || item.workspaceId === invoice.workspaceId;
  const issuers = businesses.filter(item => item.id === issuerId && inWorkspace(item));
  const issuer = issuers.length === 1 ? issuers[0] : null;
  const eligible = issuer ? clients.filter(item => inWorkspace(item) && (!item.issuerId || item.issuerId === issuerId)) : [];
  const matches = eligible.filter(item => clientId ? item.id === clientId : item.name === (draft?.client || invoice.client));
  return { issuer, client: matches.length === 1 ? matches[0] : null };
}

const invalid = () => { throw new Error('The recorded invoice identity is invalid. Reload the invoice.'); };
const row = value => value && typeof value === 'object' && !Array.isArray(value) ? value : invalid();
const text = (value, required = false) => {
  if (value == null && !required) return null;
  if (typeof value !== 'string' || value.length > 1000 || [...value].some(char => char.charCodeAt(0) < 32 || char.charCodeAt(0) === 127)
    || /[\u202a-\u202e\u2066-\u2069]/u.test(value) || (required && !value.trim())) return invalid();
  return value;
};

export function parseInvoiceDocumentIdentity(value, invoice) {
  if (value == null) return null;
  const identity = row(value);
  if (invoice.status === 'draft' || !['status_change', 'import', 'legacy_baseline'].includes(identity.source)
    || typeof identity.id !== 'string' || !/^[1-9]\d{0,18}$/.test(identity.id)
    || typeof identity.capturedAt !== 'string' || identity.capturedAt.length > 64 || !Number.isFinite(Date.parse(identity.capturedAt))) return invalid();
  const party = (value, id) => {
    const item = row(value);
    if (!id || item.id !== id) return invalid();
    return { id, name: text(item.name, true), ...Object.fromEntries(['legalName', 'email', 'location', 'countryCode', 'vatNumber', 'taxNumber'].map(key => [key, text(item[key])])) };
  };
  return { id: identity.id, source: identity.source, capturedAt: identity.capturedAt,
    issuer: party(identity.issuer, invoice.businessId), client: party(identity.client, invoice.clientId) };
}

export function recordedInvoiceParties(invoice, draft) {
  const identity = !draft && invoice?.documentIdentity;
  if (!identity || invoice.status === 'Draft') return null;
  // A current logo or contact person is not part of the captured document identity.
  return { issuer: { ...identity.issuer, initials: identity.issuer.name.split(/\s+/).slice(0, 2).map(word => word[0]).join(''), tone: 'workspace' }, client: identity.client };
}
